import styled, { useTheme } from 'styled-components';
import LS from '../styles/layoutStyled'
import CS from '../styles/componentStyled'
import AlarmModal2 from './AlarmModal2';
import AlarmModal3 from './AlarmModal3';
import React, {useState, useRef, useMemo, useEffect} from 'react';
import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil';
import { accessTokenState, refreshTokenState, expireState } from '../atom/TokenAtom';
import { alarmModal1Text } from '../atom/ModalAtom';
import { AssociationDto } from '../model/association.dto';
import { ApiService } from '../api';
import { loadingSpinnerState } from '../atom/ModalAtom';

interface MembershipCardModalProps {
    mode : string;
    onClose : () => void;
    modifyItem : any;
}

const MembershipCardModal = ({ mode, onClose, modifyItem }: MembershipCardModalProps)=> {
    const setAlarmText = useSetRecoilState(alarmModal1Text);
    const [loadingState, setLoadingState] = useRecoilState(loadingSpinnerState);
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
    const [refreshToken, setRefreshToken] = useRecoilState(refreshTokenState);
    const [expire, setExpire] = useRecoilState(expireState);
    const apiService = new ApiService();

    // 회원 번호
    const [userNumber, setUserNumber] = useState(mode === '' ? modifyItem.membership_number : '');
    const [userNumberDuplication, setUserNumberDuplication] = useState(mode === '' ? true : false);
    const handleUserNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setUserNumber(value);
        setUserNumberDuplication(false);
    };

    // 회원 번호 중복 조회
    const handleDuplicateHits: any = async () => {
        if (userNumber.length === 0) {
            setAlarmText("입력된 값이 없습니다.");
            return;
        }
        try {
            if (!accessToken) {
                throw new Error('Access token not found');
            }
            const duplication = await apiService.duplicateHitsNumber(accessToken, userNumber);
            if (duplication) {
                setUserNumberDuplication(true);
                setAlarmText("사용 가능한 회원 번호입니다.");
            }
        } catch (error: any) {
            setUserNumberDuplication(false);
            setAlarmText("중복된 회원 번호입니다.");
        }
    }

    // 이름
    const [name, setName] = useState(mode === '' ? modifyItem.name : '');
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setName(value);
    };

    // 소속
    const [belong, setBelong] = useState(mode === '' ? modifyItem.association_name : '');
    const handleBelongChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setBelong(value);
    };

    // 휴대폰 번호
    const [phoneNumber, setPhoneNumber] = useState(mode === '' ? modifyItem.phone_number : '');
    const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPhoneNumber(value);
    };
    
    // 유효기간
    const today = new Date().toISOString().split('T')[0];
    const oneYearLater = new Date();
    oneYearLater.setFullYear(oneYearLater.getFullYear() + 1);
    const settingDate = oneYearLater.toISOString().split('T')[0];
    const [expirationPeriod, setExpirationPeriod] = useState<string>(mode === '' ? modifyItem.exp_date : settingDate);
    const handleExpirationPeriodChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setExpirationPeriod(e.target.value);
    };

    // 휴대폰 번호 유효성 검사
    const validatePhoneNumber = (number: string): boolean => {
        const phoneNumberRegex = /^010\d{8}$/;
        return phoneNumberRegex.test(number);
    };

    // 유효성 검사
    const validation = () => {
        if (userNumber === null || name === '' || expirationPeriod === '' || phoneNumber === '') {
            setAlarmText("빈 칸을 확인해 주세요.");
            return true;
        }
        else if (!validatePhoneNumber(phoneNumber)) {
            setAlarmText("휴대폰 번호 형식이 올바르지 않습니다.");
            return true;
        }
        else return false;
    }

    // 등록
    const api = useMemo(() => new ApiService(), []);
    const handleSubmit: any = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validation()) return;
        if (!userNumberDuplication) {
            setAlarmText("시설물 번호 중복 조회를 해주세요.");
            return;
        }
        const formData: AssociationDto = {
            name: name,
            membership_number: userNumber,
            phone_number: phoneNumber,
            association_name: belong.trim() === '' ? '-' : belong,
            exp_date: expirationPeriod
        };
        try {
            if (!accessToken) return;
            await api.associationAdd(accessToken, formData);
            setLoadingState(true);
            window.location.reload();
        } catch (error: any) {
            setAlarmText("게시글 등록 중 오류가 발생했습니다.");
        }
    }

    // 수정 확인 모달
    const [isModifyConfirmModal, setIsModifyConfirmModal] = useState(false);
    const openModifyConfirmModal = () => {
        if (validation()) return;
        setIsModifyConfirmModal(true);
    }
    const closeModifyConfirmModal = () => {
        setIsModifyConfirmModal(false);
    }

    // 수정 모달에서 확인 버튼 클릭시
    const handleModify: any = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const formData: AssociationDto = {
            name: name,
            membership_number: userNumber,
            phone_number: phoneNumber,
            association_name: belong.trim() === '' ? '-' : belong,
            exp_date: expirationPeriod
        };
        try {
            if (!accessToken) return;
            await api.putAssociation(accessToken, formData);
            setLoadingState(true);
            window.location.reload();
        } catch (error: any) {
            setAlarmText("게시글 수정 중 오류가 발생했습니다.");
        }
    }

    return (
        <>
            <AlarmModal2>
                <h2>건축물 안전 협회 회원증 {mode === 'add' ? "등록" : "수정"}</h2>
                <form onSubmit={mode === 'add' ? handleSubmit : handleModify}>
                    <ul className="input-area">
                        <li>
                            <ul>
                                <li>
                                    <h3>회원 번호<span>*</span></h3>
                                    <div className="input-btn-box">
                                        <CS.TextInputType1
                                            placeholder='회원 번호'
                                            type='text'
                                            value={userNumber}
                                            onChange={handleUserNumberChange}
                                            disabled={mode === '' ? true : false}
                                        />
                                        <CS.Btn4Type1
                                            type='button'
                                            onClick={handleDuplicateHits}
                                            disabled={mode === '' ? true : false}
                                        >
                                        중복 조회
                                        </CS.Btn4Type1>
                                    </div>
                                </li>
                                <li>
                                    <h3>이름<span>*</span></h3>
                                    <CS.TextInputType1
                                        placeholder='이름'
                                        type='text'
                                        value={name}
                                        onChange={handleNameChange}
                                    />
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h3>소속</h3>
                                    <CS.TextInputType1
                                        placeholder='소속'
                                        type='text'
                                        value={belong}
                                        onChange={handleBelongChange}
                                    />
                                </li>
                                <li>
                                    <h3>휴대폰 번호<span>*</span></h3>
                                    <CS.TextInputType1
                                        placeholder='휴대폰 번호(-자 제외)'
                                        type='text'
                                        value={phoneNumber}
                                        onChange={handlePhoneNumberChange}
                                        maxLength={11}
                                    />
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h3>유효기간<span>*</span></h3>
                                    <CS.TextInputType1
                                        placeholder='측정 항목'
                                        type='date'
                                        value={expirationPeriod}
                                        onChange={handleExpirationPeriodChange}
                                        min={today}
                                        className='selected'
                                    />
                                </li>
                                <li></li>
                            </ul>
                        </li>
                    </ul>
                    <div className="btn-box">
                        <CS.Btn2Type2 type='button' onClick={onClose}>취소</CS.Btn2Type2>
                        {mode === 'add' && (
                            <CS.Btn2Type1 type='submit'>확인</CS.Btn2Type1>
                        )}
                        {mode === '' && (
                            <CS.Btn2Type1 type='button' onClick={openModifyConfirmModal}>수정</CS.Btn2Type1>
                        )}
                    </div>
                </form>
            </AlarmModal2>

            {isModifyConfirmModal && (
                <AlarmModal3
                    modalType='modify'
                    onClose={closeModifyConfirmModal}
                    onConfirm={handleModify}
                />
            )}
        </>
    );
}

export default MembershipCardModal;